import { createSlice } from "@reduxjs/toolkit";

import { getContext } from "../../data";

const initialState = getContext();

const initDefaultValues = (state) => {
  for (const key in state) {
    if (state.hasOwnProperty(key)) {
      const element = state[key];
      const properties = element.properties || [];
      for (const prop of properties) {
        const { id, defaultValue } = prop;
        if (!element.state) {
          element.state = {};
        }
        if (!element.property) {
          element.property = {};
        }
        element.state[id] = defaultValue;
        element.property[id] = prop;
      }
    }
  }
  return state;
};

const decorate = (state, action) => {
  const { payload } = action;
  let { path } = payload;
  if (typeof path === "string") {
    path = path.split("/");
  }
  const [target, prop] = path || [];
  const decorator = state[target].property[prop]?.decorator;

  if (decorator) {
    if (typeof decorator === "function") {
      decorator(state, action);
    }
    if (typeof decorator === "object") {
      const value = state[target].state[prop];
      if (typeof value === "boolean" && value) {
        for (const key in decorator) {
          state[target].state[key] = decorator[key];
        }
      }
    }
  }
};

export const contextSlice = createSlice({
  name: "context",
  initialState: initDefaultValues(initialState),
  reducers: {
    setValue: (state, action) => {
      const { payload } = action;
      let { path, value } = payload;
      if (typeof path === "string") {
        path = path.split("/");
      }
      const [target, prop] = path || [];

      if (state[target]?.state?.hasOwnProperty(prop)) {
        state[target].state[prop] = value;
        decorate(state, action);
      }
    },
    toggleValue: (state, action) => {
      const { payload } = action;
      let { path } = payload;
      if (typeof path === "string") {
        path = path.split("/");
      }
      const [target, prop] = path || [];

      if (state[target]?.state?.hasOwnProperty(prop)) {
        if (state[target].property[prop]?.type === "Boolean") {
          state[target].state[prop] = !state[target].state[prop];
        }
        if (
          state[target].property[prop]?.type === "Select" &&
          Array.isArray(state[target].property[prop]?.options)
        ) {
          const options = state[target].property[prop]?.options;
          const currentValue = state[target].state[prop];
          const currentValueIndex = options.findIndex((option) =>
            typeof option === "object"
              ? option.value === currentValue
              : option === currentValue
          );
          const nextValueIndex =
            currentValueIndex + 1 < options.length ? currentValueIndex + 1 : 0;
          const nextValue =
            typeof options[nextValueIndex] === "object"
              ? options[nextValueIndex].value
              : options[nextValueIndex];

          state[target].state[prop] = nextValue;
        }

        decorate(state, action);
      }
    },
    toggleTopic: (state, { payload }) => {
      if (state.tractor.state.topic === payload) {
        state.tractor.state.topic = null;
      } else {
        state.tractor.state.topic = payload;
      }
    },
    resetValue: (state, { payload }) => {},
    addProperty: (state, { payload }) => {},
    removeProperty: (state, { payload }) => {},
  },
});

export const {
  setValue,
  toggleValue,
  toggleTopic,
  resetValue,
  addProperty,
  removeProperty,
} = contextSlice.actions;

export const selectLanguage = (state) => state.context.user.state.language;
export const selectLanguages = (state) =>
  state.context.user.properties.find((prop) => prop.id === "language")?.options;
export const selectView = (state) => state.context.tractor.state.view;

export default contextSlice.reducer;
